export default {
  // Header
  'header.home': 'ホーム',
  'header.about': 'About',
  'header.research': 'Research',
  'header.career': 'Career',
  'header.media': 'Media & Links',
  'header.blog': 'Blog & Articles',
  'header.contact': 'Contact',

  // Language Switcher
  'lang.ja': '日本語',
  'lang.en': 'English',

  // Common Buttons
  'common.viewProfile': 'プロフィールを見る',
  'common.contact': 'お問い合わせ',
  'common.readArticle': '記事を読む',
  'common.showMore': 'もっと見る',
  'common.viewAllArticles': 'noteで全ての記事を見る',
  'common.externalLink': '外部リンク',
};
